import React, { useState, useEffect } from "react"
import { feedbackCollectionInstance } from "utils/feedback-collection/instance"

import { useAuth } from "hooks/auth/use-auth"
import { injectRequestInterceptor } from "utils/axios-utils"
import { AuthLoadingPlaceholder } from "containers/router/auth-router/callback"
import AuthContext from "./auth.context"

const RENTSPREE_SUBDOMAINS = ["rentspree", "www", "files", "info", "apply"]

const isRentspreeSubdomain = subdomain =>
  RENTSPREE_SUBDOMAINS.some(rentspreeSubdomain =>
    subdomain.includes(rentspreeSubdomain)
  )

export const AuthWrapper = ({ subdomain, children }) => {
  const {
    isAuthenticated,
    isLoading,
    getAccessToken,
    getPartnerOrganizationByName
  } = useAuth()
  const [isInitializedAuth, setIsInitializedAuth] = useState(false)
  const [partnerOrganization, setPartnerOrganization] = useState(undefined)

  useEffect(
    () => {
      if (isLoading) return
      injectRequestInterceptor({
        getAccessToken
      })
      if (isAuthenticated) {
        feedbackCollectionInstance.setAuthConfiguration({
          getAccessToken
        })
      }
      setIsInitializedAuth(true)
    },
    [isAuthenticated, isLoading, getAccessToken]
  )

  useEffect(
    () => {
      const setOrganization = async () => {
        try {
          const organization = await getPartnerOrganizationByName(subdomain)
          setPartnerOrganization(organization)
        } catch (error) {
          setPartnerOrganization({})
        }
      }

      if (subdomain && !isRentspreeSubdomain(subdomain)) {
        setOrganization()
      } else {
        setPartnerOrganization({})
      }
    },
    [subdomain]
  )

  if (!isInitializedAuth || !partnerOrganization)
    return <AuthLoadingPlaceholder />

  return (
    <AuthContext.Provider value={{ authContext: true, partnerOrganization }}>
      {children}
    </AuthContext.Provider>
  )
}
